/**
 * @file 注册百度 App 端能力对象
 * @author weijiaxun <weijiaxun@baidu.com>
 */
import { nativeRegister } from '../index';
import is from '../baidubox/is';
nativeRegister('baidubox', {
    is,
    load(callback) {
        import(/* webpackChunkName: "native_baidubox" */ '../baidubox/index')
            .then(function ({ invoker: native }) {
            callback(native);
        });
    }
});
//# sourceMappingURL=baidubox.js.map